import { useCommonStore } from '@/stores/common';

export default {
  data() {
    return {
      common: useCommonStore()
    };
  }
};
